import React from 'react';

export const SettingsIcon = ({ className }) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="8.5" cy="15.5" r="7.5" stroke="white" strokeWidth="2" />
			<path d="M13 9L21.1667 1M22 7L18.5 4" stroke="white" strokeWidth="2" strokeLinecap="round" />
		</svg>
	);
};
